/**
 * Approximate unit price next to a balance-sheet stock quantity.
 */
export function formatStockVerificationHint(netAmount, stockQty, stockUnit, stockVerifyDisplay) {
  if (stockVerifyDisplay) {
    return stockVerifyDisplay;
  }
  const qty = parseFloat(stockQty);
  const net = parseFloat(netAmount);
  if (!qty || qty <= 0 || !net || net <= 0) {
    return null;
  }
  const unit = (stockUnit || 'unit').trim();
  const rateFormatted = (net / qty).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `~₹${rateFormatted}/${unit}`;
}

export function balanceSheetRowNetAmount(drtamount, crtamount) {
  const dr = parseFloat(drtamount) || 0;
  const cr = parseFloat(crtamount) || 0;
  if (dr > cr) {
    return dr - cr;
  }
  if (cr > dr) {
    return cr - dr;
  }
  return 0;
}
